<template>
  <a-config-provider
    :class="bem.b()"
    v-bind="attrs"
    :theme="theme"
    :auto-insert-space-in-button="autoInsertSpaceInButton"
    :component-size="componentSize"
    :locale="antLocale"
  >
    <!-- 默认插槽 -->
    <slot />
    <!-- 自定义空数据 -->
    <slot name="renderEmpty" />
  </a-config-provider>
</template>
<script lang="ts" setup>
import { computed, useAttrs } from 'vue'

import { ANT_LOCALE_LIST, DEFAULT_LOCALE } from '@ll-plus/locale/config'
import { createNamespace } from '@ll-plus/utils'
import { theme as antTheme } from 'ant-design-vue'
import dayjs from 'dayjs'
import {
  configProviderProps,
  DEFAULT_THEME_MODE,
  THEME_ENUM,
} from './config-provider'
import { useConfigProvider } from './hooks'

import type { IAntLocaleItem } from '@ll-plus/locale/config'
import { isObject } from 'lodash-es'

defineOptions({
  name: 'LlConfigProvider',
})

const attrs = useAttrs()
const props = defineProps(configProviderProps)

const { provideGlobalConfig, setTheme } = useConfigProvider()

// 设置ant的国际化
const { defaultAlgorithm } = antTheme
const antLocale = computed(() => {
  const locale = props.locale as any
  if (locale && locale.name) {
    const newLocale = ANT_LOCALE_LIST.find(
      (item) => item.name === locale.name
    ) as IAntLocaleItem
    dayjs.locale(locale.name)
    return newLocale.locale
  }
  dayjs.locale(DEFAULT_LOCALE)
  return null
})
// 设置主题
const theme = computed(() => {
  if (props.theme && isObject(props.theme)) {
    const {
      type = DEFAULT_THEME_MODE,
      inherit = true,
      components,
      extraToken = {},
    } = props.theme
    props.theme.extraToken
    let { token, algorithm = defaultAlgorithm } = props.theme
    // 如果传入了主题类型则用内置的主题 否则用自定义的
    token = { ...extraToken }
    if (type && THEME_ENUM[type]) {
      const storageTheme = type || (DEFAULT_THEME_MODE as THEME_ENUM)
      const themeToken = setTheme(storageTheme)
      algorithm = themeToken.algorithm
      token = { ...themeToken.token, ...extraToken }
    }
    return {
      token,
      inherit,
      algorithm,
      components,
    }
  }
  return {}
})
const bem = createNamespace('config-provider')

// 设置全局的proxy（例如国际化）
provideGlobalConfig(computed(() => props))
</script>

<style lang="less" scoped></style>
